
export enum enumHotCardPersonRelationship {
  Spouse = 1,
  Children,
  Parent,
  Supervisor,
  Family,
  Friend,
  'Next of Kin',
  MaxBank,
  'Card Holder'
}

export namespace enumHotCardPersonRelationship {
  export function values() {
    return Object.keys(enumHotCardPersonRelationship).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
